import { LogoutMessageKey } from '@infomaniak/ksuite-bridge';
import { Component, getAssetPath, h, Host, Prop, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import userStore from '../../stores/store';
import { ADMIN_TYPE, OWNER_TYPE, RESTRICT_LEGAL_ENTITY_TYPE } from '../../utils/utils';

@Component({
  tag: 'menu-user',
  styleUrl: 'menu-user.scss',
  shadow: true,
})
export class MenuUser {
  @State() visible: boolean;
  @Prop() readonly loading: boolean = true;
  @Prop() readonly closeLayout: () => void = () => null;

  private menuSkeleton = () => {
    return (
      <div class="skeleton">
        <div class="skeleton--avatar" />
        <div class="skeleton--username" />
        <div class="skeleton--mail" />
        <div class="skeleton--link" />
        <div class="skeleton--button" />
      </div>
    );
  };

  private handleLogout = (e: MouseEvent) => {
    if (wcShared.store.ksuiteBridge?.isConnected) {
      wcShared.store.ksuiteBridge?.sendMessage({ type: LogoutMessageKey });
    } else {
      wcShared.store.utils.goToLink(e, { url: this.getLogoutLink() }, false);
    }
  };

  private getLogoutLink() {
    switch (window['CURRENT_PROJECT']) {
      case 'ksuite':
        return wcShared.store?.productsRouting?.welcome + '/auth/logout?project=ksuite';
      case 'ai-tools':
        return wcShared.store?.productsRouting?.welcome + '/auth/logout?project=ai-tools';
      case 'shop':
        return '/auth/logout';
      case 'welcome':
        return '/auth/logout';
      case 'drive':
        return '/app/auth/logout';
      case 'workspace3':
        return '/logout';
      case 'kmeet':
        return wcShared.store?.productsRouting?.welcome + '/auth/logout?project=kmeet';
      case 'chk':
        return wcShared.store?.productsRouting?.welcome + '/auth/logout?project=chk';
      case 'traductions':
        return '/logout';
      case 'kpaste':
        return wcShared.store?.productsRouting?.welcome + '/auth/logout?with_login_redirect=1';
      case 'hosting3':
        return wcShared.store?.productsRouting?.welcome + '/auth/logout?with_login_redirect=1';
      case 'etickets':
        return wcShared.store?.productsRouting?.welcome + '/auth/logout?with_login_redirect=1';
      default:
        return '/shared/superadmin/logout.php';
    }
  }

  render() {
    if (this.loading) return this.menuSkeleton();

    return (
      <Host>
        <svg
          width="17"
          height="16"
          viewBox="0 0 17 16"
          xmlns="http://www.w3.org/2000/svg"
          class="cross"
          fill="currentColor"
          onClick={this.closeLayout}
          role="button"
        >
          <path d="M16.8535 0.852577C17.0492 0.657315 17.0492 0.340732 16.8535 0.14547C16.6578 -0.0497921 16.3405 -0.0497921 16.1448 0.14547L8.98254 7.29192L1.82028 0.14547C1.62459 -0.0497921 1.30731 -0.0497921 1.11161 0.14547C0.91592 0.340732 0.91592 0.657315 1.11161 0.852577L8.27386 7.99902L1.11161 15.1455C0.91592 15.3407 0.91592 15.6573 1.11161 15.8526C1.30731 16.0478 1.62459 16.0478 1.82028 15.8526L8.98254 8.70613L16.1448 15.8526C16.3405 16.0478 16.6578 16.0478 16.8535 15.8526C17.0492 15.6573 17.0492 15.3407 16.8535 15.1455L9.69121 7.99902L16.8535 0.852577Z" />
        </svg>
        <div class="layout">
          {Boolean(userStore.currentUser?.id) ? (
            <div class="profile">
              <module-avatar-component
                class="profile__avatar"
                size={42}
                name={userStore.currentUser?.firstname + ' ' + userStore.currentUser?.lastname}
                logo={userStore.currentUser?.avatar}
                accountId={userStore.currentUser?.id}
              ></module-avatar-component>
              <div class="profile__name">{userStore.currentUser?.display_name}</div>
              <div class="profile__mail">{userStore.currentUser?.email}</div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${wcShared?.store?.productsRouting?.manager}/v3/${userStore.currentUser?.current_account_id}/ng/profile`}
                class="profile__profile-link"
              >
                {wcShared?.translate('Gerer mon profil')}
              </a>
              {[ADMIN_TYPE, OWNER_TYPE].includes(userStore.currentGroup?.type) &&
                userStore.currentGroup?.legal_entity_type !== RESTRICT_LEGAL_ENTITY_TYPE &&
                !wcShared.store.ksuiteBridge?.isConnected &&
                window?.['CURRENT_PROJECT'] !== 'ksuite' && <group-manage />}
              <button
                class="profile__logout-btn"
                onClick={this.handleLogout}
              >
                <img
                  src={getAssetPath('./../assets/icons/power-switch.svg')}
                  alt={wcShared?.translate('Deconnexion')}
                ></img>
                {wcShared?.translate('Deconnexion')}
              </button>
            </div>
          ) : (
            <div class="user-disconnected">
              <div class="user-disconnected__icon">
                <img
                  src={getAssetPath('./../assets/icons/power-switch.svg')}
                  alt={wcShared?.translate('Deconnexion')}
                ></img>
              </div>
              <div class="user-disconnected__title">
                {wcShared?.translate('Vous etes deconnecte')}
              </div>
              <div class="user-disconnected__description">
                {wcShared?.translate('Reconnectez-vous pour acceder a vos produits')}
              </div>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  wcShared?.store?.productsRouting?.welcome +
                  '/auth/login?project=' +
                  window?.['CURRENT_PROJECT']
                }
              >
                <button type="button">{wcShared?.translate('Se connecter')}</button>
              </a>
            </div>
          )}
        </div>
      </Host>
    );
  }
}
